module.exports = __webpack_public_path__ + "static/media/LeftDisbaled.f146ec66.svg";